<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <form @submit.prevent="updateLetterContent">
                                <div class="form-group">
                                    <label for="letter-content-create">
                                        Content
                                    </label>
                                    <textarea
                                        v-model="content"
                                        class="form-control"
                                        id="letter-content-create"
                                        rows="4"
                                        placeholder="Textarea"
                                    ></textarea>
                                    <button
                                        type="button"
                                        class="btn-sm btn-outline-success mt-50"
                                        @click="spinLetterContent"
                                    >
                                        Spin
                                    </button>
                                </div>
                                <div class="form-group">
                                    <label for="letter-content-type">
                                        Type
                                    </label>
                                    <select v-model="type" class="form-control" id="letter-content-type">
                                        <option value="1">Inquiry Letter Content</option>
                                        <option value="2">Inquiry Letter Content Heading</option>
                                        <option value="3">Personal Information Content</option>
                                        <option value="4">Account Content</option>
                                        <option value="5">Footer Sign Off</option>
                                        <option value="6">Footer Content</option>
                                        <option value="7">Letter Content Title</option>
                                        <option value="8">Account Detail Content</option>
                                    </select>
                                </div>
                                <router-link
                                    :to="{ name: 'list-letter-content' }"
                                    v-slot="{ href, route, navigate }"
                                >
                                    <button type="button" @click="navigate" class="btn btn-primary">
                                        Back
                                    </button>
                                </router-link>
                                <button type="submit" class="ml-2 btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>

</style>
<script>
    import { ref, reactive } from 'vue'
    import { useSettingStore } from '../../stores/SettingStore.js'
    import Swal from 'sweetalert2'
    export default {
        props: {
        },
        setup()
        {
            return{
                content : ref(null),
                type : ref(null),
                baseUrl: baseUrl,
                settingStore: useSettingStore(),
            }
        },
        methods:{
            updateLetterContent()
            {
                let $this = this,
                props = $this.$router.resolve({ 
                    name: 'view-letter-content',
                    params: { letter_content: $this.$route.params.letter_content }
                });
                axios.put(
                    $this.baseUrl + props.path,
                    {
                        content: $this.content,
                        type: $this.type
                    }
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            },
            spinLetterContent()
            {
                let $this = this,
                payload = {
                    content: $this.content,
                    tags: []
                };
                let swal = Swal.fire({
                    title: "Spinner!",
                    // icon: 'info',
                    html: `<span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span> In Progress wait for sometime`,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    willOpen: function (element) {
                        element.querySelector('.swal2-html-container').classList.add('d-flex');
                        element.querySelector('.swal2-html-container').classList.add('align-items-center');
                        element.querySelector('.swal2-html-container').classList.add('justify-content-center');
                    }
                });
                const route = this.$router.resolve(
                    {
                        name: 'spin-letter',
                    }
                );
                axios.post(
                    route.href,
                    payload
                )
                .then(function (response) {
                    swal.close();
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.content = response.data.data;
                    return;
                })
                .catch(function (error) {
                    swal.close();
                    toastr.error(error.message, 'Error!');
                });
            }
        },
        computed: {
        },
        mounted()
        {
            if (_.isNull(useSettingStore().setting)) {
                useSettingStore().fetchSetting();
            }
            let $this = this,
            props = $this.$router.resolve(
                {
                    name: 'view-letter-content',
                    params: { letter_content: $this.$route.params.letter_content }
                }
            );
            axios.get(
                this.baseUrl + props.path,
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                $this.type = response.data.data.type;
                $this.content = response.data.data.content;
                return;
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
            });            
        }
    }
</script>
